import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const FLEET_SIDENAV_LINKS = new InjectionToken<void>("FLEET_SIDENAV_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("fleet", [
      {
        id: "vehicleType",
        label: "FLEET.ITEMS.VEHICLE_TYPES",
        icon: "cubes",
        routerLink: "/fleet/vehicle-types",
        permissions: COMMON_GUARD_OPTIONS.VEHICLE_TYPE.VIEW.permissions,
      },
      {
        id: "groupManagement",
        label: "FLEET.ITEMS.GROUP_MANAGEMENT",
        icon: "group-management",
        permissions: [...COMMON_GUARD_OPTIONS.PARENT_GROUP.VIEW.permissions, ...COMMON_GUARD_OPTIONS.GROUP.VIEW.permissions],
        expanded: true,
        items: [
          {
            id: "parentGroup",
            label: "FLEET.ITEMS.PARENT_GROUPS",
            routerLink: "/fleet/parent-groups",
            permissions: COMMON_GUARD_OPTIONS.PARENT_GROUP.VIEW.permissions,
          },
          {
            id: "groups",
            label: "FLEET.ITEMS.GROUPS",
            routerLink: "/fleet/groups",
            permissions: COMMON_GUARD_OPTIONS.GROUP.VIEW.permissions,
          },
        ],
      },
      {
        id: "Features",
        label: "FLEET.ITEMS.FEATURES",
        icon: "features",
        routerLink: "/fleet/features",
        permissions: COMMON_GUARD_OPTIONS.FEATURE.VIEW.permissions,
      },
      {
        id: "Vehicles",
        label: "FLEET.ITEMS.VEHICLES",
        icon: "car",
        routerLink: "/fleet/vehicles",
        permissions: COMMON_GUARD_OPTIONS.VEHICLE.VIEW.permissions,
      },
      {
        id: "FuelManagement",
        label: "FLEET.ITEMS.FUEL_MANAGEMENT",
        icon: "jerrycan",
        permissions: [...COMMON_GUARD_OPTIONS.FUEL_TYPE.VIEW.permissions, ...COMMON_GUARD_OPTIONS.FUEL_PRICE_LOG.VIEW.permissions],
        expanded: true,
        items: [
          {
            id: "FuelTypes",
            label: "FLEET.ITEMS.FUEL_TYPES",
            routerLink: "/fleet/fuel-types",
            permissions: COMMON_GUARD_OPTIONS.FUEL_TYPE.VIEW.permissions,
          },
          {
            id: "FuelPriceLogs",
            label: "FLEET.ITEMS.FUEL_PRICE_LOGS",
            routerLink: "/fleet/fuel-price-logs",
            permissions: COMMON_GUARD_OPTIONS.FUEL_PRICE_LOG.VIEW.permissions,
          },
        ],
      },
      {
        id: "CargoCategories",
        label: "FLEET.ITEMS.CARGO_CATEGORIES",
        icon: "car",
        routerLink: "/fleet/cargo-categories",
        permissions: COMMON_GUARD_OPTIONS.CARGO_CATEGORY.VIEW.permissions,
      },
      {
        id: "VehicleFiles",
        label: "FLEET.ITEMS.VEHICLE_FILES",
        icon: "files2",
        routerLink: "/fleet/vehicle-files",
        permissions: COMMON_GUARD_OPTIONS.VEHICLE_FILE.VIEW.permissions,
      },
      {
        id: "TireManagement",
        icon: "tire",
        label: "FLEET.ITEMS.TIRES_MANAGEMENT",
        items: [
          {
            id: "TireTypes",
            label: "FLEET.ITEMS.TIRE_TYPES",
            routerLink: "/fleet/tire-types",
            permissions: COMMON_GUARD_OPTIONS.TIRE_TYPE.VIEW.permissions,
          },
          {
            id: "TireBrands",
            label: "FLEET.ITEMS.TIRE_BRANDS",
            routerLink: "/fleet/tire-brands",
            permissions: COMMON_GUARD_OPTIONS.TIRE_BRAND.VIEW.permissions,
          },
          {
            id: "TireModels",
            label: "FLEET.ITEMS.TIRE_MODELS",
            routerLink: "/fleet/tire-models",
            permissions: COMMON_GUARD_OPTIONS.TIRE_MODEL.VIEW.permissions,
          },
          {
            id: "TireCatalogs",
            label: "FLEET.ITEMS.TIRE_CATALOGS",
            routerLink: "/fleet/tire-catalogs",
            permissions: COMMON_GUARD_OPTIONS.TIRE_CATALOG.VIEW.permissions,
          },
        ],
      },
      {
        id: "suppliesManagement",
        label: "FLEET.ITEMS.SUPPLIES_MANAGEMENT",
        icon: "cart",
        permissions: [
          ...COMMON_GUARD_OPTIONS.SUPPLY_TYPE.VIEW.permissions,
          ...COMMON_GUARD_OPTIONS.LEASING_TYPE.VIEW.permissions,
          ...COMMON_GUARD_OPTIONS.PROPERTY_TYPE.VIEW.permissions,
          ...COMMON_GUARD_OPTIONS.POST_RENTING_TYPE.VIEW.permissions,
          ...COMMON_GUARD_OPTIONS.SUPPLY.VIEW.permissions,
        ],
        expanded: true,
        items: [
          {
            id: "Supplies",
            label: "FLEET.ITEMS.SUPPLIES",
            routerLink: "/fleet/supplies",
            permissions: COMMON_GUARD_OPTIONS.SUPPLY.VIEW.permissions,
          },

          {
            id: "configuration",
            label: "FLEET.ITEMS.CONFIGURATION",
            icon: "configuration",
            permissions: [
              ...COMMON_GUARD_OPTIONS.SUPPLY_TYPE.VIEW.permissions,
              ...COMMON_GUARD_OPTIONS.LEASING_TYPE.VIEW.permissions,
              ...COMMON_GUARD_OPTIONS.PROPERTY_TYPE.VIEW.permissions,
              ...COMMON_GUARD_OPTIONS.POST_RENTING_TYPE.VIEW.permissions,
            ],
            expanded: true,
            items: [
              {
                id: "SupplyTypes",
                label: "FLEET.ITEMS.SUPPLY_TYPES",
                routerLink: "/fleet/supply-types",
                permissions: COMMON_GUARD_OPTIONS.SUPPLY_TYPE.VIEW.permissions,
              },
              {
                id: "LeasingTypes",
                label: "FLEET.ITEMS.LEASING_TYPES",
                routerLink: "/fleet/leasing-types",
                permissions: COMMON_GUARD_OPTIONS.LEASING_TYPE.VIEW.permissions,
              },
              {
                id: "PropertyTypes",
                label: "FLEET.ITEMS.PROPERTY_TYPES",
                routerLink: "/fleet/property-types",
                permissions: COMMON_GUARD_OPTIONS.PROPERTY_TYPE.VIEW.permissions,
              },
              {
                id: "PostRentingTypes",
                label: "FLEET.ITEMS.POST_RENTING_TYPES",
                routerLink: "/fleet/post-renting-types",
                permissions: COMMON_GUARD_OPTIONS.POST_RENTING_TYPE.VIEW.permissions,
              },
            ],
          },
        ],
      },
      {
        id: "damagesManagement",
        label: "FLEET.ITEMS.DAMAGES_MANAGEMENT",
        icon: "damage-management",
        permissions: [
          ...COMMON_GUARD_OPTIONS.DIAGRAM.VIEW.permissions,
          ...COMMON_GUARD_OPTIONS.DAMAGE_TYPE.VIEW.permissions,
          ...COMMON_GUARD_OPTIONS.DAMAGE_LEVEL.VIEW.permissions,
          ...COMMON_GUARD_OPTIONS.ELEMENT_CATEGORY.VIEW.permissions,
          ...COMMON_GUARD_OPTIONS.ELEMENT.VIEW.permissions,
        ],
        expanded: true,
        items: [
          {
            id: "Damages",
            label: "FLEET.ITEMS.DAMAGES",
            routerLink: "/fleet/damage",
            permissions: COMMON_GUARD_OPTIONS.DAMAGE.VIEW.permissions,
          },
          {
            id: "evaluation-reports",
            label: "FLEET.ITEMS.EVALUATION_REPORTS",
            routerLink: "/fleet/evaluation-reports",
            permissions: COMMON_GUARD_OPTIONS.EVALUATION_REPORT.VIEW.permissions,
          },

          {
            id: "configuration",
            label: "FLEET.ITEMS.CONFIGURATION",
            icon: "configuration",
            permissions: [
              ...COMMON_GUARD_OPTIONS.DIAGRAM.VIEW.permissions,
              ...COMMON_GUARD_OPTIONS.DAMAGE_TYPE.VIEW.permissions,
              ...COMMON_GUARD_OPTIONS.DAMAGE_LEVEL.VIEW.permissions,
              ...COMMON_GUARD_OPTIONS.ELEMENT_CATEGORY.VIEW.permissions,
              ...COMMON_GUARD_OPTIONS.ELEMENT.VIEW.permissions,
            ],
            expanded: true,
            items: [
              {
                id: "diagram",
                label: "FLEET.ITEMS.DIAGRAM",
                routerLink: "/fleet/diagram",
                permissions: COMMON_GUARD_OPTIONS.DIAGRAM.VIEW.permissions,
              },
              {
                id: "DamageTypes",
                label: "FLEET.ITEMS.DAMAGE_TYPES",
                routerLink: "/fleet/damage-types",
                permissions: COMMON_GUARD_OPTIONS.DAMAGE_TYPE.VIEW.permissions,
              },
              {
                id: "DamageLevels",
                label: "FLEET.ITEMS.DAMAGE_LEVELS",
                routerLink: "/fleet/damage-levels",
                permissions: COMMON_GUARD_OPTIONS.DAMAGE_LEVEL.VIEW.permissions,
              },
              {
                id: "ElementCategories",
                label: "FLEET.ITEMS.ELEMENT_CATEGORIES",
                routerLink: "/fleet/element-categories",
                permissions: COMMON_GUARD_OPTIONS.ELEMENT_CATEGORY.VIEW.permissions,
              },
              {
                id: "Element",
                label: "FLEET.ITEMS.ELEMENTS",
                routerLink: "/fleet/element",
                permissions: COMMON_GUARD_OPTIONS.ELEMENT.VIEW.permissions,
              },
              {
                id: "ElementComponent",
                label: "FLEET.ITEMS.ELEMENT_COMPONENT",
                routerLink: "/fleet/element-component",
                permissions: COMMON_GUARD_OPTIONS.ELEMENT_COMPONENT.VIEW.permissions,
              },
              {
                id: "diagramCostMatrix",
                label: "FLEET.ITEMS.DIAGRAM_COST_MATRIX",
                routerLink: "/fleet/diagram-cost-matrix",
                permissions: COMMON_GUARD_OPTIONS.DIAGRAM_COST_MATRIX.VIEW.permissions,
              },
            ],
          },
        ],
      },
      {
        id: "incidents",
        label: "FLEET.ITEMS.INCIDENTS",
        icon: "incident",
        routerLink: "/fleet/incidents",
        permissions: COMMON_GUARD_OPTIONS.INCIDENT.VIEW.permissions,
      },
      {
        id: "fleet-check",
        label: "FLEET.ITEMS.FLEET_CHECK",
        icon: "fleet-check",
        routerLink: "/fleet/fleet-check",
        permissions: COMMON_GUARD_OPTIONS.FLEET_CHECK.VIEW.permissions,
      },
    ]);
  },
});
